import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from '../register.view.css';
import { toSignupTestId } from './StepFormPrimitives';

type CodeResendHelpProps = {
  disabled: boolean;
  onResendCode: () => void;
};

export const CodeResendHelp = (p: CodeResendHelpProps) => (
  <div className={styles.codeHelpBlock}>
    <Typography variant="body" size="medium" className={styles.codeHelpText}>
      Please check your spam if you do not see it in your inbox.
    </Typography>
    <Button
      type="button"
      variant="text"
      color="primary"
      size="large"
      testId={toSignupTestId('code', 'resend', 'button')}
      className={styles.codeResendButton}
      onClick={p.onResendCode}
      disabled={p.disabled}
    >
      Didn&apos;t receive a code? Send again
    </Button>
  </div>
);
